import { Logo } from "@/components/ui/logo";
import { useTheme } from "@/hooks/use-theme";

interface AuthLayoutProps {
  children: React.ReactNode;
}

export function AuthLayout({ children }: AuthLayoutProps) {
  const { resolvedTheme } = useTheme();
  // Peppermint (blue→white gradient) reads great on the dark hero but its
  // lower half fades into a light background, so fall back to flat manor
  // blue in light mode.
  const heroTone = resolvedTheme === "dark" ? "peppermint" : "blue";

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-primary-50 via-white to-accent-50 dark:from-gray-900 dark:via-gray-900 dark:to-gray-800 px-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <Logo
            variant="full"
            tone={heroTone}
            className="text-4xl sm:text-5xl mx-auto"
          />
          <p className="mt-3 mb-6 sm:mb-12 font-display italic tracking-wide text-sm sm:text-base text-gray-600 dark:text-gray-300">
            Your properties in your pocket.
          </p>
        </div>
        {children}
      </div>
    </div>
  );
}
